export default "__VITE_ASSET__DYVCBzD7__"